"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportReportByCustomerExcel = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _fileSaver = require("file-saver");
var Excel = _interopRequireWildcard(require("exceljs"));
var _index = require("@/utils/index");
var _report = require("@/types/report");
var _utils = require("./utils");
var cellStyle = {
  border: {
    top: {
      style: "medium",
      color: {
        argb: "#000"
      }
    },
    left: {
      style: "medium",
      color: {
        argb: "#000"
      }
    },
    bottom: {
      style: "medium",
      color: {
        argb: "#000"
      }
    },
    right: {
      style: "medium",
      color: {
        argb: "#000"
      }
    }
  }
};
var styleCell = {
  primaryCell: {
    font: {
      size: 12
    },
    border: cellStyle.border,
    alignment: {
      vertical: "middle",
      wrapText: true
    }
  },
  boldCell: {
    font: {
      bold: true,
      size: 12
    },
    border: cellStyle.border,
    alignment: {
      horizontal: "center",
      vertical: "middle",
      wrapText: true
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: "ffffff"
      },
      bgColor: {
        argb: "ffffff"
      }
    }
  },
  totalCell: {
    font: {
      bold: true,
      size: 12,
      color: {
        argb: 'FF0000'
      }
    },
    border: cellStyle.border,
    alignment: {
      horizontal: "center",
      vertical: "middle",
      wrapText: true
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: {
        argb: "FFFF00"
      },
      bgColor: {
        argb: "FFFF00"
      }
    }
  }
};
var listColor = ['B4C6E7', 'F8CBAD', 'FFE699', 'C6E0B4'];
var startTableRow = 0;
var exportReportByCustomerExcel = exports.exportReportByCustomerExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, fromDate, toDate, fileName, workbook, worksheet, titleCell, monthsInRange, dataByCustomer, i, element, color, styleBoldCell, dataByProduct, headerRow, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, fromDate = _ref.fromDate, toDate = _ref.toDate;
          // config export excel
          fileName = "Consignment Sales Statement";
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Consignment", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2,
              xSplit: 1
            }]
          }); //set title table
          titleCell = worksheet.getCell('A1');
          if (fromDate && toDate) {
            titleCell.value = "H\xC0NG K\xDD G\u1EECI_CONSIGNMENT SALES STATEMENT: ".concat(fromDate, " - ").concat(toDate);
          } else {
            titleCell.value = "H\xC0NG K\xDD G\u1EECI_CONSIGNMENT SALES STATEMENT";
          }
          titleCell.style = {
            font: {
              color: {
                argb: 'ffFF6600'
              },
              size: 16,
              bold: true
            }
          };
          //
          //add table
          startTableRow = 2;
          // const startTable = worksheet.getCell(`A${startTableRow++}`);
          // startTable.style = {
          //   font: {
          //     color: {
          //       argb: "ffff0202",
          //     },
          //   },
          // };
          // Array to store the list of months
          monthsInRange = (0, _utils.getMonthRange)(fromDate, toDate);
          dataByCustomer = (0, _utils.transformDataByCustomerExport)(data);
          for (i = 0; i < dataByCustomer.length; i++) {
            element = dataByCustomer[i];
            startTableRow += 1;
            color = {
              argb: listColor[i % 4]
            };
            styleBoldCell = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styleCell.boldCell), {}, {
              fill: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styleCell.boldCell.fill), {}, {
                fgColor: color,
                bgColor: color
              }),
              font: {
                bold: true,
                size: 12,
                color: {
                  argb: 'FF0000'
                }
              }
            });
            generateTable(worksheet, element.products, element.customerName, monthsInRange, styleBoldCell);
          }
          startTableRow += 3;
          dataByProduct = (0, _utils.transformDataByProductExport)(data);
          generateTotalTable(worksheet, dataByProduct, monthsInRange);
          headerRow = worksheet.getRow(3);
          headerRow.eachCell(function (cell, colNum) {
            var address = cell.address.replace(/[0-9]/g, '');
            //merge cot
            if (colNum == monthsInRange.length * 3 + 1) {
              worksheet.mergeCells("A1:".concat(address, "1"));
            }
          });
          _context.next = 18;
          return workbook.xlsx.writeBuffer();
        case 18:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportReportByCustomerExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// generate danh sach table san pham theo khach hang
var generateTable = function generateTable(worksheet, products, customerName, monthsInRange, colorStyleCell) {
  //add table
  var columnTable = [{
    labels: [customerName],
    style: colorStyleCell,
    width: 60,
    prop: "productName",
    numFmt: undefined
  }];
  for (var i = 0; i < monthsInRange.length; i++) {
    var element = monthsInRange[i];
    var month = element.replace('.', '');
    columnTable.push({
      labels: [element, 'Đã ký gửi/ Deposited'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalDeposit',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Hàng tặng kèm/ Gift goods'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalDepositGift',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Đã bán từ hàng ký gửi/ Sold from consignment'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalSaleConsign',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Đã bán từ hàng tặng/ Sold from gift goods'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalSaleGiveaway',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Còn lại trước khi thu hồi hàng/ Remaining amount before recall'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalRemainBeforeReturn',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Thu hồi lại hàng ký gửi/ Consignment recovery'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalReturnConsignment',
      numFmt: '#,##0'
    }, {
      labels: [element, 'Còn lại/ Remaining Total'],
      style: styleCell.boldCell,
      width: 20,
      prop: month + 'totalRemain',
      numFmt: '#,##0'
    });
  }
  updateMergeTable(worksheet, columnTable, colorStyleCell);
  //generate data
  var data = [];
  products.forEach(function (e, index) {
    var tmp = [];
    var totalRemain = 0;
    var _loop = function _loop() {
      var month = monthsInRange[_i].replace('.', '');
      var find = e.months.find(function (e) {
        return e.month == month;
      });
      e[month + 'totalRemain'] = totalRemain;
      if (find) {
        for (var _i2 = 0; _i2 < _report.listKeysReportConsign.length; _i2++) {
          var key = _report.listKeysReportConsign[_i2];
          e[month + key] = find[key];
        }
        e[month + 'totalRemainBeforeReturn'] = find.totalRemainBeforeReturn + totalRemain;
        e[month + 'totalRemain'] = find.totalRemain + totalRemain;
        totalRemain = find.totalRemain + totalRemain;
      }
    };
    for (var _i = 0; _i < monthsInRange.length; _i++) {
      _loop();
    }
    columnTable.forEach(function (col) {
      var value = (0, _index.generateProp)((0, _objectSpread2.default)({}, e), col.prop);
      var productNameStyle = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, colorStyleCell), {}, {
        alignment: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, colorStyleCell.alignment), {}, {
          horizontal: "left"
        })
      });
      var style = col.prop == 'productName' ? productNameStyle : styleCell.primaryCell;
      tmp.push({
        value: value,
        style: style,
        numFmt: col.numFmt
      });
    });
    data.push(tmp);
  });
  var startRow = startTableRow + 2;
  data.forEach(function (element) {
    var row = worksheet.getRow(startRow++);
    row.values = element.map(function (e) {
      return e.value;
    });
    row.eachCell(function (cell, index) {
      var col = element[index - 1];
      // @ts-ignore
      cell.style = col.style;
      col.numFmt && (cell.numFmt = col.numFmt);
      // element.numFmt && (worksheet.getCell(`${tmpChar}${rowIndex}`).numFmt = element.numFmt)
    });
  });
  startTableRow = startRow;
};
// generate tong san pham con lai
var generateTotalTable = function generateTotalTable(worksheet, products, monthsInRange) {
  //add table
  var columnTable = [{
    labels: ['TOTAL'],
    style: styleCell.totalCell,
    width: 60,
    prop: "productName",
    numFmt: undefined
  }];
  for (var i = 0; i < monthsInRange.length; i++) {
    var element = monthsInRange[i];
    columnTable.push({
      labels: [element],
      style: styleCell.totalCell,
      width: 20,
      prop: element.replace('.', '') + 'total',
      numFmt: '#,##0'
    });
  }
  updateMergeTable(worksheet, columnTable, styleCell.totalCell);
  //generate data
  var data = [];
  products.forEach(function (e, index) {
    var tmp = [];
    var totalRemain = 0;
    var _loop2 = function _loop2() {
      var month = monthsInRange[_i3].replace('.', '');
      var find = e.months.find(function (e) {
        return e.month == month;
      });
      e[month + 'total'] = totalRemain;
      if (find) {
        e[month + 'total'] = find.totalRemain + totalRemain;
        totalRemain = find.totalRemain + totalRemain;
      }
    };
    for (var _i3 = 0; _i3 < monthsInRange.length; _i3++) {
      _loop2();
    }
    columnTable.forEach(function (col) {
      var value = (0, _index.generateProp)((0, _objectSpread2.default)({}, e), col.prop);
      var productNameStyle = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styleCell.totalCell), {}, {
        alignment: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, styleCell.totalCell.alignment), {}, {
          horizontal: undefined
        })
      });
      var style = productNameStyle;
      tmp.push({
        value: value,
        style: style,
        numFmt: col.numFmt
      });
    });
    data.push(tmp);
  });
  var startRow = startTableRow + 2;
  data.forEach(function (element) {
    var row = worksheet.getRow(startRow++);
    row.values = element.map(function (e) {
      return e.value;
    });
    row.eachCell(function (cell, index) {
      var col = element[index - 1];
      // @ts-ignore
      cell.style = col.style;
      col.numFmt && (cell.numFmt = col.numFmt);
      // element.numFmt && (worksheet.getCell(`${tmpChar}${rowIndex}`).numFmt = element.numFmt)
    });
  });
  startTableRow = startRow;
};
// function merge row, col cell
var updateMergeTable = function updateMergeTable(worksheet, columnTable, styleCell) {
  var mergeRows = {};
  var mergeCols = {};
  var _loop3 = function _loop3(index) {
    var rowIndex = startTableRow + index;
    var headerRow = worksheet.getRow(rowIndex);
    headerRow.values = columnTable.map(function (e) {
      return "";
    });
    headerRow.height = index == 0 ? 15 : 60;
    headerRow.eachCell(function (cell, colNum) {
      var col = columnTable[colNum - 1];
      var address = cell.address.replace(/[0-9]/g, '');
      if (!mergeRows[address]) {
        mergeRows[address] = [rowIndex];
      }
      var mergeAddress = mergeRows[address];
      var label = col.labels[index];
      if (label) {
        cell.value = label;
        mergeAddress[0] = rowIndex;
        if (!mergeCols[label]) {
          mergeCols[label] = [];
        }
        if (index == 0) {
          mergeCols[label].push(cell.address);
        }
      } else {
        mergeAddress.push(rowIndex);
      }
      //merge cot
      if (index == 1 && mergeAddress.length > 1) {
        worksheet.mergeCells("".concat(address).concat(mergeAddress[0], ":").concat(address).concat(mergeAddress[mergeAddress.length - 1]));
      }
      // @ts-ignore
      cell.style = col.style;
    });
    var columns = worksheet.columns;
    columns.forEach(function (col, i) {
      var _columnTable$i;
      col.width = (columnTable === null || columnTable === void 0 || (_columnTable$i = columnTable[i]) === null || _columnTable$i === void 0 ? void 0 : _columnTable$i.width) || 20;
    });
  };
  for (var index = 0; index < 2; index++) {
    _loop3(index);
  }
  //merge dong
  Object.entries(mergeCols).forEach(function (e) {
    var cellAddress = e[1];
    if (cellAddress.length > 1) {
      worksheet.mergeCells("".concat(cellAddress[0], ":").concat(cellAddress[cellAddress.length - 1]));
      var cell = worksheet.getCell("".concat(cellAddress[0], ":").concat(cellAddress[cellAddress.length - 1]));
      cell.style = styleCell;
    }
  });
};